/**
 * Client/build-time: optional Jupiter Plugin extras from NEXT_PUBLIC_* vars.
 * Referral: https://station.jup.ag/tool-kits/referral-program
 *
 * Branding defaults to IDX Swap + `/idx-logo-mark.png` (absolute URL); override with
 * NEXT_PUBLIC_JUPITER_PLUGIN_NAME / NEXT_PUBLIC_JUPITER_PLUGIN_LOGO_URI when needed.
 */

import { getSiteOrigin } from "@/lib/siteUrl";

const DEFAULT_JUPITER_PLUGIN_NAME = "IDX Swap";
const DEFAULT_JUPITER_LOGO_PATH = "/idx-logo-mark.png";

function trimEnv(key) {
  const v = process.env[key];
  return typeof v === "string" ? v.trim() : "";
}

/** @returns {{ referralAccount?: string; referralFee?: number }} */
export function getJupiterFormPropsExtras() {
  const referralAccount = trimEnv("NEXT_PUBLIC_JUPITER_REFERRAL_ACCOUNT");
  const feeRaw = trimEnv("NEXT_PUBLIC_JUPITER_REFERRAL_FEE_BPS");
  const out = {};
  if (referralAccount.length > 0) {
    out.referralAccount = referralAccount;
    const fee = Number.parseInt(feeRaw, 10);
    if (Number.isFinite(fee) && fee > 0) out.referralFee = fee;
  }
  return out;
}

/** @returns {{ logoUri: string; name: string }} */
export function getJupiterBranding() {
  const logoUriEnv = trimEnv("NEXT_PUBLIC_JUPITER_PLUGIN_LOGO_URI");
  const nameEnv = trimEnv("NEXT_PUBLIC_JUPITER_PLUGIN_NAME");
  return {
    name: nameEnv || DEFAULT_JUPITER_PLUGIN_NAME,
    logoUri:
      logoUriEnv || `${getSiteOrigin()}${DEFAULT_JUPITER_LOGO_PATH}`,
  };
}
